<button type="button"
        class="btn col vert-0050 assess__btn"
        [ngClass]="getClass(info)"
        [attr.data-test-id]="'asessmentLevel_'+ info.level + '_btn'"
        *ngFor="let info of assessmentInfos"
        [matTooltip]="info.detailedDescription || info.description"
        #tooltip="matTooltip"
        (click)="onLevelClicked(info)">
  <span [ngClass]="!horizontal ? 'assessAdd__num' : 'assessUpdate__num'">
    <ng-container *ngIf="info.level">{{info.level}}</ng-container>
    <i class="far fa-minus"
       *ngIf="!info.level"></i>
  </span>
  <span class="assess__desc">{{info.description}}</span>
</button>
